import Api from '@/api'
const resource = 'events'

export default {
  deleteInteraction (interactionId) {
    return Api.delete(`/${resource}/${interactionId}`)
  },

  updateInteraction (interactionId, data) {
    return Api.put(`/${resource}/${interactionId}`, { event: data })
  }
}
